export default "__VITE_ASSET__Bcx19Y1g__"